import React from "react";
import {
    CheckCircleIcon,
    ExclamationTriangleIcon,
    XCircleIcon
} from "@heroicons/react/24/outline";
import { useDarkMode } from "../../contexts/darkModeContext";

const notificationTypes = {
    warning: {
        color: "yellow",
        icon: <ExclamationTriangleIcon className="size-5 stroke-2 text-yellow-600" />,
        borderColor: "border-yellow-600",
        bgColor: "bg-yellow-600/25",
        textColor: "text-yellow-600",
        linkHover: "hover:text-yellow-600",
        barColor: "bg-yellow-600",
        barBg: "bg-yellow-400",
    },
    success: {
        color: "green",
        icon: <CheckCircleIcon className="size-5 stroke-2 text-green-600" />,
        borderColor: "border-green-600",
        bgColor: "bg-green-600/25",
        textColor: "text-green-600",
        linkHover: "hover:text-green-600",
        barColor: "bg-green-600",
        barBg: "bg-green-400",
    },
    error: {
        color: "red",
        icon: <XCircleIcon className="size-5 stroke-2 text-red-600" />,
        borderColor: "border-red-600",
        bgColor: "bg-red-600/25",
        textColor: "text-red-600",
        linkHover: "hover:text-red-600",
        barColor: "bg-red-600",
        barBg: "bg-red-400",
    },
};

const Notification = ({ type = "warning", message, linkText, isVisible }) => {
    const { darkMode } = useDarkMode();
    const config = notificationTypes[type] || notificationTypes.warning;

    return (
        <div className={`w-fit max-w-sm border-l-4 rounded-r-xl transition-all duration-300 ${isVisible ? "animate-slideInRightBounce" : "animate-slideOutRightBounce"} shadow-2xl ${config.borderColor} ${darkMode ? 'bg-darkMainColor' : 'bg-white'}`}>
            <div className={`${config.bgColor} w-full h-full p-2 rounded-r-xl`}>
                <div className="flex">
                    <div className="shrink-0">{config.icon}</div>
                    <div className="ml-3">
                        <p className={`flex text-sm ${config.textColor}`}>
                            {message}{" "}
                            <div className={`ml-2 font-medium ${config.textColor} ${config.linkHover}`}>
                                {linkText}
                            </div>
                        </p>
                    </div>
                </div>

                {/* Loading bar */}
                <div className={`relative mt-2 h-1 w-full rounded-full ${config.barBg} overflow-hidden`}>
                    <div className={`absolute left-0 top-0 h-full rounded-full ${config.barColor} animate-fill-bar`}></div>
                </div>
            </div>
        </div>
    );
};

export default Notification;
